// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"400b5507","455":"f32097e4","977":"97df50b0"}[chunkId] + ".chunk.js";
};